import React, { useRef, useImperativeHandle, forwardRef } from "react";
import GoogleReCAPTCHA from "react-google-recaptcha";
import styles from "./ReCAPTCHA.module.css";

export interface ReCAPTCHAInterface {
    execute: () => Promise<string | null>;
}

const ReCAPTCHA = forwardRef<ReCAPTCHAInterface, {}>((_, ref) => {
    const recaptchaRef = useRef<GoogleReCAPTCHA>(null);

    // Imperatively expose the execute function to the parent component
    useImperativeHandle(ref, () => ({
        execute: () => {
            if (recaptchaRef.current) {
                return recaptchaRef.current.executeAsync();
            }
            return Promise.resolve(null);
        },
    }));

    return (
        <div className={styles.recaptchaContainer}>
            <GoogleReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}
                size="invisible"
                ref={recaptchaRef}
            />
        </div>
    );
});

export default ReCAPTCHA;
